import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getRedirectLink, getStoreInfo } from "../api/apiServices";
import { RedrirectContext, useData } from "../context/RedirectContext";

const useRedirect = (p_id, s_id, timeout = 1000) => {
  const apiURLRef = useRef(null);
  const timeOutIdRef = useRef(null);

  const navigate = useNavigate();
  const { setData } = useData();

  useEffect(() => {
    let timeOutId;
    setData((prev) => ({ ...prev, isLoading: true }));
    (async () => {
      try {
        const [storeData, redirectURLData] = await Promise.all([
          getStoreInfo({ sid: s_id }),
          getRedirectLink({ pid: p_id, sid: s_id }),
        ]);
        if (redirectURLData?.link && storeData?.data) {
          apiURLRef.current = redirectURLData.link;

          setData({
            storeData,
            redirectURLData,
            timeOutId,
            isLoading: false,
          });
        }
      } catch (error) {
        console.error("Error during API call:", error);
        apiURLRef.current = null;
        setData((prev) => ({ ...prev, isError: true }));
        navigate("/");
      }
    })();

    timeOutId = setTimeout(() => {
      const redirectURL = apiURLRef.current;
      if (redirectURL) {
        window.location.replace(redirectURL);
      }
    }, timeout);
    timeOutIdRef.current = timeOutId;
    return () => {
      clearTimeout(timeOutId);
    };
  }, [p_id, s_id, navigate, timeout]);

  return [timeOutIdRef];
};

export default useRedirect;
